<script>
  import axios from "axios";
  import { link } from "svelte-spa-router";
  import Layout from "../../Layout/Layout.svelte";
  import MenuHeading from "../../shared/MenuHeading.svelte";
  import config from "../../stores/config";
  import Select from "svelte-select";
  import { Circle } from "svelte-loading-spinners";
  import * as ls from "local-storage";

  let uploading = false;

  let title = null;
  let fullName = null;
  let customerType = null; // ["business", "individual"]
  let companyName = null;
  let email = null;
  let tel = null;
  let secondTel = null;
  let website = null;
  let billingAddress = null;
  let shippingAddress = null;

  const handleClear = () => {
    title = null;
    fullName = null;
    customerType = null;
    companyName = null;
    email = null;
    tel = null;
    secondTel = null;
    website = null;
    billingAddress = null;
    shippingAddress = null;
  };

  const handleSubmit = async (e) => {
    if (
      $config.customers.find(({ label }) =>
        $config.f._has_(label, `${fullName} ${companyName}`)
      )
    ) {
      alert("⚠ This Customer already exists");
      return;
    }

    if (!title) alert("Customer Title Missing!");
    else if (!fullName) alert("Customer fullName missing!");
    else if (!customerType) alert("Customer Type missing!");
    else if (!companyName) alert("Company Name missing!");
    else if (!email) alert("Customer email missing!");
    else if (!tel) alert("Customer tel missing!");
    else if (!billingAddress) alert("Billing Address missing!");
    else if (!shippingAddress) alert("Shipping Address missing!");
    else {
      uploading = true;

      let data = {
        title,
        fullName,
        customerType,
        companyName,
        email,
        tel,
        secondTel,
        website,
        billingAddress,
        shippingAddress,
      };

      axios
        .post(`${$config.backendURL}/customers`, data, {
          headers: { authorization: ls.get("jwt") },
        })
        .then((res) => {
          console.log(res.data);
          uploading = false;
          alert(`☑ Added Successfully`);
          window.location.reload();
          handleClear();
        })
        .catch((err) => {
          alert("There was a problem, Refresh the page and retry");
          console.log(err);
          uploading = false;
        });
    }
  };
</script>

<svelte:head>
  <title>Add a Customer | Fabi CC System</title>
</svelte:head>

<Layout>
  <MenuHeading
    title="Add a new Customer"
    description="Fill out the form below to enter the customer details. All fields are REQUIRED."
  />

  <div class="flex justify-end mb-6">
    <a class="btn btn-green-outline" use:link href="/customers">
      <i class="fas fa-arrow-left mr-3" />
      Return to Customers
    </a>
  </div>

  <form
    on:submit|preventDefault={handleSubmit}
    class="grid grid-cols-1 gap-y-4 text-gray-500 pb-8"
  >
    <div class="grid grid-cols-2 gap-8">
      <div class="grid grid-cols-3 gap-2 items-center">
        <div>Title :</div>
        <input
          class="col-span-2 shadow-sm placeholder-gray-300"
          type="text"
          bind:value={title}
          placeholder="Title"
          required
        />
      </div>
      <div class="grid grid-cols-3 gap-2 items-center">
        <div>Contact Person :</div>
        <input
          class="col-span-2 shadow-sm placeholder-gray-300"
          type="text"
          bind:value={fullName}
          placeholder="Contact Person"
          required
        />
      </div>
    </div>

    <div class="grid grid-cols-2 gap-8">
      <div class="grid grid-cols-3 gap-2 items-center">
        <div>Customer Type :</div>
        <div class="col-span-2">
          <Select
            items={["business", "individual"]}
            selectedValue={customerType}
            on:select={(e) => (customerType = e.detail.value)}
          />
        </div>
      </div>
      <div class="grid grid-cols-3 gap-2 items-center">
        <div>Company Name :</div>
        <input
          class="col-span-2 shadow-sm placeholder-gray-300"
          type="text"
          bind:value={companyName}
          placeholder="Company Name"
          required
        />
      </div>
    </div>

    <div class="grid grid-cols-2 gap-8">
      <div class="grid grid-cols-3 gap-2 items-center">
        <div>Telephone :</div>
        <input
          class="col-span-2 shadow-sm placeholder-gray-300"
          type="text"
          bind:value={tel}
          placeholder="Telephone"
          required
        />
      </div>
      <div class="grid grid-cols-3 gap-2 items-center">
        <div>Email :</div>
        <input
          class="col-span-2 shadow-sm placeholder-gray-300"
          type="text"
          bind:value={email}
          placeholder="Email"
          required
        />
      </div>
    </div>

    <div class="grid grid-cols-2 gap-8">
      <div class="grid grid-cols-3 gap-2 items-center">
        <div>Cell :</div>
        <input
          class="col-span-2 shadow-sm placeholder-gray-300"
          type="text"
          bind:value={secondTel}
          placeholder="Cell if Any"
        />
      </div>
      <div class="grid grid-cols-3 gap-2 items-center">
        <div>Website :</div>
        <input
          class="col-span-2 shadow-sm placeholder-gray-300"
          type="text"
          bind:value={website}
          placeholder="Website if Any"
        />
      </div>
    </div>

    <div class="grid grid-cols-2 gap-8">
      <div class="grid grid-cols-3 gap-2 items-center">
        <div>Billing Address :</div>
        <textarea
          class="col-span-2 shadow-sm placeholder-gray-300"
          type="text"
          bind:value={billingAddress}
          placeholder="Billing Address"
          required
        />
      </div>
      <div class="grid grid-cols-3 gap-2 items-center">
        <div>Shipping Address :</div>
        <textarea
          class="col-span-2 shadow-sm placeholder-gray-300"
          type="text"
          bind:value={shippingAddress}
          placeholder="Shipping Address"
          required
        />
      </div>
    </div>

    {#if uploading}
      <div class="grid grid-cols-1 gap-8">
        <div class="flex items-center justify-center btn btn-green-outline">
          <Circle size="25" color="rgb(16, 185, 129)" unit="px" />
          <span class="ml-4">Please wait...</span>
        </div>
      </div>
    {:else}
      <!-- else content here -->
      <div class="grid grid-cols-2 gap-8">
        <button class="btn btn-green-outline" on:click={handleClear}>
          <i class="fas fa-times-circle mr-3" />
          Clear Form
        </button>
        <button class="btn btn-green">
          <i class="fas fa-check-circle mr-3" />
          Save to Database
        </button>
      </div>
    {/if}
  </form>
</Layout>
